import { Moment } from 'moment';
import { useState } from 'react';
import { SelectValue } from '../../../Components/Base/Select/Select';
import { getMomentDate } from '../../../Utils/dates.util';

export default function useFilters() {
	const DATE_FROM_TIME = 'T00:00:00Z';
	const DATE_TO_FORMAT = 'T23:59:59Z';

	const [isDateRangeVisible, setIsDateRangeVisible] = useState(false);

	const checkEmptyString = (val?: string) => {
		return val?.trim()?.length ? val : undefined;
	};

	const handleSelect = (val: SelectValue) => {
		return val.value && typeof val.value === 'string'
			? checkEmptyString(val.value)
			: undefined;
	};

	const handleSelectValue = (val: string) => {
		if (val) {
			return checkEmptyString(val);
		}
		return undefined;
	};

	const handleMultiSelectValue = (val: SelectValue[]) => {
		if (val && val.length > 0) {
			return val.map((item: SelectValue) => item.value as string);
		}
		return undefined;
	};

	const handleDateValue = (val: string | Moment | undefined) => {
		if (val) {
			return getMomentDate(val).format('YYYY-MM-DD');
		}
		return undefined;
	};

	const handleTimeValue = (val: string | Moment | undefined) => {
		return val ? getMomentDate(val).format('HH:mm:ss') : undefined;
	};

	const handleDateValueAsMoment = (val: string | Moment | undefined) => {
		if (val) {
			return getMomentDate(val);
		}
		return undefined;
	};

	const handleDateTimeValue = (
		val: string | Moment | undefined,
		time: string = '00:00:00',
	) => {
		if (val) {
			return getMomentDate(val).format('YYYY-MM-DD') + `T${time}Z`;
		}
		return undefined;
	};

	const handleDateRange = (from?: string | Moment, to?: string | Moment) => {
		if (!from || !to) {
			return undefined;
		}
		return {
			from: getMomentDate(from).format('YYYY-MM-DD') + DATE_FROM_TIME,
			to: getMomentDate(to).format('YYYY-MM-DD') + DATE_TO_FORMAT,
		};
	};

	const handleDateRangeVisibility = (pickerValue: string) => {
		setIsDateRangeVisible(pickerValue === 'DATE_RANGE');
	};

	const handleDateRangeInPicker = (pickerValue: string) => {
		return pickerValue === 'DATE_RANGE' ? undefined : pickerValue;
	};

	const handleQuestionnaireSeenFilter = (pickerValue?: string) => {
		if (pickerValue) {
			switch (pickerValue) {
				case 'ONLY_SEEN':
					return true;
				case 'ONLY_NOT_SEEN':
					return false;
			}
		}
		return undefined;
	};

	const handleBoolean = (value: any): boolean => {
		return typeof value === 'boolean' ? value : false;
	};

	function convertToUpperCase(input?: string): string | undefined {
		if (!input) {
			return undefined;
		}
		return input.toUpperCase();
	}

	const handleFloat = (value?: string): number | undefined => {
		return value && checkEmptyString(value) ? parseFloat(value) : undefined;
	};

	return {
		checkEmptyString,
		handleSelectValue,
		handleMultiSelectValue,
		handleDateValue,
		handleDateTimeValue,
		handleDateRange,
		handleDateRangeVisibility,
		handleDateRangeInPicker,
		handleQuestionnaireSeenFilter,
		handleDateValueAsMoment,
		handleBoolean,
		isDateRangeVisible,
		convertToUpperCase,
		handleTimeValue,
		handleSelect,
		handleFloat,
	};
}
